








































































































import { Component, Vue } from 'vue-property-decorator';
    @Component({
      components: {

      },
    })
export default class App extends Vue {
  menu = [];

  mounted() {
    this.$http.get('menu.json').then((response) => {
      this.menu = response.data;
      window.localStorage.setItem('menu', JSON.stringify(this.menu));
    });
  }

  listado(index : number, index2 : number, item : any) {
    window.localStorage.setItem('item', JSON.stringify(item));
    this.$router.push(`/listado/${(index)}/${(index2)}`);
  }

  romano(numero: number) {
    switch (numero) {
      case 1: return 'I';
      case 2: return 'II';
      case 3: return 'III';
      case 4: return 'IV';
      case 5: return 'V';
      case 6: return 'VI';
      case 7: return 'VII';
      case 8: return 'VIII';
      default: return '';
    }
  }
}
